// Emersya always triggers events on the 'message' event name
// inside of the event we have event.data.action which contains the proper action name
// onBasketCreated when a configuration was created
// onQuit when a customer leaves the configurator
class EmersyaConfigurator {
    constructor() {
      this.container = document.getElementById('configuratorContent');
      this.showConfgiurator = false;
  
      if (!this.container) console.error("Couldn't find the container for the configurator");
  
      this._registerEvents();
    }
  
    _registerEvents() {
      window.addEventListener('message', async (event) => {
        switch (event.data.action) {
          case 'onBasketCreated':
            // no basket code given
            if (!event?.data?.data?.code) return;
  
            this._createAndAddToBasket(event.data.data.code);
          case 'onQuit':
            this._closeConfigurator();
          default:
            return;
        }
      });
  
      document.querySelectorAll('[data-emersya-start]').forEach((startConfiguratorButton) =>
        startConfiguratorButton.addEventListener('click', (event) => {
          // make sure nothing weird happens due to the wrapping form or other stuff from webflow
          event.preventDefault();
          event.stopPropagation();
  
          this._initConfigurator(startConfiguratorButton.dataset.emersyaStart);
        })
      );
    }
  
    _initConfigurator(emersyaConfiguratorSKU) {
      // nothing to do here because no sku is defined
      if (!emersyaConfiguratorSKU) return console.log('No SKU for Emersya configurator defined');
  
      this.container.classList.add('show');
  
      const emersyaAppLoader = document.createElement('SCRIPT');
      emersyaAppLoader.setAttribute('containerId', 'configuratorContent');
      emersyaAppLoader.setAttribute('code', 'BUUZ9X5W76');
      emersyaAppLoader.setAttribute('data-model', emersyaConfiguratorSKU);
      this.container.appendChild(emersyaAppLoader);
      emersyaAppLoader.setAttribute('src', 'https://cdn.emersya.com/f/emersyaAppLoader.min.js');
    }
  
    _closeConfigurator() {
      this.container.innerHTML = '';
      this.container.classList.remove('show');
    }
  
    async _createAndAddToBasket(emersyaBasketCode) {
      const response = await fetch(`https://emersya.herokuapp.com/product/${emersyaBasketCode}`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          code: emersyaBasketCode,
        }),
      });
  
      const data = await response.json();
  
      // early return if we don't have a valid response
      if (!data)
        return console.error(
          'No data received from Emersya, tried to fetch:',
          `https://emersya.herokuapp.com/${emersyaBasketCode}`
        );
  
      // add the newly created products to cart
      const addItemsToCartResponse = await fetch(`/cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [...data],
        }),
      });
  
      const addItemsToCartData = await addItemsToCartResponse.json();
  
      // early return if we don't have a valid list of products
      if (!addItemsToCartData) return console.error('No data added to cart, tried:', { items: [...data] });
  
      this.container.classList.remove('show');
  
      // dispatch udesly event to open the cart
      document.body.dispatchEvent(new CustomEvent('cart-should-be-updated'));
      document.body.dispatchEvent(new CustomEvent('product-added-to-cart'));
    }
  }
  
  const configurator = new EmersyaConfigurator();